import { useState, useImperativeHandle, forwardRef, useEffect } from 'react';
import DigitProvider from './DigitProvider';

export interface TimerRef {
	start: () => void;
	stop: () => void;
	reset: () => void;
}

interface TimerProps {
	setTimeIsUp: (value: boolean) => void;
}

const Timer = forwardRef<TimerRef, TimerProps>((props, ref) => {
	const [time, setTime] = useState(0);
	const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);

	useEffect(() => {
		if (time >= 999) {
			props.setTimeIsUp(true);
			stop();
		}
	}, [time]);

	const reset = (): void => {
		stop();
		setTime(0);
	};

	const start = (): void => {
		if (!intervalId) {
			const newIntervalId = setInterval(() => {
				setTime((prevTime) => prevTime + 1);
			}, 1000);
			setIntervalId(newIntervalId);
		}
	};

	const stop = (): void => {
		if (intervalId) {
			clearInterval(intervalId);
			setIntervalId(null);
		}
	};

	useImperativeHandle(ref, () => ({
		start,
		stop,
		reset
	}));

	return <DigitProvider value={time}/>;
});

export default Timer;
